"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIER_II_MANAGER_SEARCH_STRINGS = exports.EMERGENCY_EQUIPMENT_CONTACT_STATES = exports.BILLING_CONTACT_STATES = exports.RCRA_INFO_STATES = exports.IDIOSYNCRATIC_STATES = exports.TIER_II_SUBMIT_STATES = exports.TIER_II_MANAGER_VA_LEPC = exports.TIER_II_MANAGER_STATES = exports.EPLAN_STATES = exports.STATES_AND_PROVINCES = exports.PROVINCES = exports.PROVINCE_TERRITORY_NAMES = exports.STATES = exports.stateNamesByAbbreviation = exports.STATE_NAMES = void 0;
exports.isStateAbbreviation = isStateAbbreviation;
exports.isCalifornia = isCalifornia;
const domainConstants = __importStar(require("encamp-domain-constants"));
const governmentAgencyIds_1 = require("./governmentAgencyIds");
exports.STATE_NAMES = domainConstants.STATE_NAMES;
exports.stateNamesByAbbreviation = domainConstants.stateNamesByAbbreviation;
exports.STATES = Object.keys(exports.STATE_NAMES);
const STATE_ABBREVIATION_SET = new Set(exports.STATES);
/** Whether a raw string is one of the two-letter US state abbreviations. */
function isStateAbbreviation(value) {
    return STATE_ABBREVIATION_SET.has(value);
}
exports.PROVINCE_TERRITORY_NAMES = {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NS: "Nova Scotia",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    NT: "Northwest Territories",
    NU: "Nunavut",
    YT: "Yukon",
};
exports.PROVINCES = Object.keys(exports.PROVINCE_TERRITORY_NAMES);
exports.STATES_AND_PROVINCES = [...exports.STATES, ...exports.PROVINCES];
exports.EPLAN_STATES = [
    "AL",
    "AK",
    "FL",
    "GA",
    "IA",
    "MS",
    "MT",
    "NY",
    "NC",
    "SC",
    "TN",
];
exports.TIER_II_MANAGER_STATES = [
    "AR",
    "CT",
    "DE",
    "IL",
    "IN",
    "KY",
    "MA",
    "MD",
    "MI",
    "MN",
    "ND",
    "NV",
    "OR",
    "PA",
    "WI",
    "WV",
];
exports.TIER_II_MANAGER_VA_LEPC = [
    governmentAgencyIds_1.LEPC_IDS.VA.FAIRFAX_COUNTY,
    governmentAgencyIds_1.LEPC_IDS.VA.HENRICO_COUNTY,
    governmentAgencyIds_1.LEPC_IDS.VA.PRINCE_WILLIAM_COUNTY,
];
exports.TIER_II_SUBMIT_STATES = [
    "AK",
    "AL",
    "CO",
    "FL",
    "GA",
    "HI",
    "IA",
    "ID",
    "ME",
    "MS",
    "MT",
    "NC",
    "NH",
    "NM",
    "NY",
    "OH",
    "OK",
    "RI",
    "SC",
    "TN",
    "UT",
    "VA",
    "VI",
    "VT",
    "WY",
];
exports.IDIOSYNCRATIC_STATES = [
    "AZ",
    "CA",
    "KS",
    "LA",
    "MO",
    "NE",
    "NJ",
    "SD",
    "TX",
    "WA",
];
/**
 * States that report RCRA data in the RCRAInfo portal
 */
exports.RCRA_INFO_STATES = [
    "AK",
    "AR",
    "CO",
    "CT",
    "DE",
    "DC",
    "GA",
    "HI",
    "ID",
    "IN",
    "IA",
    "LA",
    "ME",
    "MD",
    "MA",
    "NE",
    "NV",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "PA",
    "RI",
    "SC",
    "SD",
    "UT",
    "VT",
    "VA",
    "WV",
    "WI",
];
exports.BILLING_CONTACT_STATES = Array.from(new Set([...exports.EPLAN_STATES, ...exports.TIER_II_SUBMIT_STATES, "CA", "TX"]));
exports.EMERGENCY_EQUIPMENT_CONTACT_STATES = [
    "CT",
    "ME",
    "NH",
    "RI",
    "VT",
];
/**
 * California (CERS) is the only Tier II jurisdiction that accepts multiple
 * submission documents of the same type, so several features are gated on it.
 * A facility's (and therefore a report's) jurisdiction is its `state`.
 */
function isCalifornia(state) {
    return state === "CA";
}
/**
 * Known search strings from T2M portals, we can use this
 * to make sure our searches succeed in their portal.
 *
 * If this list grows, we should just make 2 dictionaries
 * from this; one for the CAS number and one for the chemicalName.
 */
exports.TIER_II_MANAGER_SEARCH_STRINGS = [
    {
        casNumber: "7664417",
        encampChemicalNames: [
            "Aqua Ammonia (20-35%)",
            "Ammonia",
            "Ammonia (Conc >20%)",
            "**Ammonia",
            "Prologue", // Nutrien Ag Solutions uses this name
        ],
        t2mChemicalName: "Ammonia",
        ehs: true,
        componentPercentageLowerBoundInclusive: 0,
        componentPercentageUpperBoundInclusive: 100,
    },
    {
        casNumber: "7664417",
        encampChemicalNames: [
            "Anhydrous Ammonia",
            "Anhudrous Ammonia",
            "Pro-Iron 5",
            // https://ehs.encamp.com/o/2f4211bd-510e-4475-bac9-5dbcc94e60d1/chemicals/catalog/chemicals/3721f5c8-722b-526f-baa5-b5a9d3cee351
            // Ammonia, Anhydrous - Duke Energy
            "Ammonia, Anhydrous",
            //https://ehs.encamp.com/o/ddba9da5-4db7-4018-bc67-78d78200022a/chemicals/catalog/chemicals/1a93d750-b176-4169-bd47-0bc85d1e648d
            "Pro Trio",
        ],
        t2mChemicalName: "Ammonia (anhydrous)",
        ehs: true,
    },
    {
        casNumber: "1910425",
        encampChemicalNames: ["Paraquat"],
        t2mChemicalName: "Paraquat dichloride",
        ehs: true,
    },
    {
        casNumber: "2074502",
        encampChemicalNames: ["Paraquat"],
        t2mChemicalName: "Paraquat methosulfate",
        ehs: true,
    },
    {
        //https://ehs.encamp.com/o/1bcb2aed-da3f-4f6d-b83f-ca248dff472d/chemicals/catalog/chemicals/3dfa9f80-2919-4638-b3f1-a995397c2d74
        // EQT - SCAL16098A
        casNumber: "7647010",
        encampChemicalNames: [
            "Hydrochloric Acid",
            "Hydrochloric Acid Solution",
            "HCL 15%",
            "Hydrochloric Acid 15%",
            "Hydrochloric Acide",
            "HCL 10.1-15%",
            "SCAL16098A",
        ],
        t2mChemicalName: "Hydrochloric acid",
        ehs: false,
    },
    {
        casNumber: "7647010",
        encampChemicalNames: ["Hydrogen chloride"],
        t2mChemicalName: "Hydrogen chloride (anhydrous)",
        ehs: true,
    },
    {
        casNumber: "7722841",
        encampChemicalNames: [
            "Hydrogen Peroxide",
            "Hydrogen Peroxide (h2o2)",
            // https://ehs.encamp.com/o/08ddd1b2-9e21-4907-a4c7-520371b73bbd/chemicals/catalog/chemicals/17e4ecfe-a663-44d6-bf10-2014b43f9ea0
            // Thermo Fisher Scientific - Hydrogen Peroxide Solution
            "Hydrogen Peroxide Solution",
            //https://ehs.encamp.com/o/ddba9da5-4db7-4018-bc67-78d78200022a/chemicals/catalog/chemicals/a958a516-1eaa-4314-aed7-c2f26ea7f870
            // Nutrien Ag Solutions - Hydrogen Peroxide (20-40%)
            "Hydrogen Peroxide (20-40%)",
            // https://ehs.encamp.com/o/66579c52-4923-4bcf-8ae8-1502310184c3/chemicals/catalog/chemicals/83737b3f-2211-4cc0-b6a4-ef28a543f15c
            // Rivian - GardobondH7002 (50% hydrogen peroxide)
            "GardobondH7002 (50% hydrogen peroxide)",
            // https://ehs.encamp.com/o/a3e04932-18d2-48a4-a0a6-eb86eab23f93/chemicals/catalog/chemicals/709f4674-8b3d-48a9-b7ca-538a427da932
            // Covetrus - Hydrogen Peroxide 3% strength
            "Hydrogen Peroxide 3% strength",
            // https://ehs.encamp.com/o/238d7a91-39d1-4173-954b-4e1544aca9b5/chemicals/catalog/chemicals/96091a86-1ee4-4ba7-89ef-d7c5bed73cce
            // Tosca - Hydrogen peroxide (Conc.< 52%)
            "Hydrogen peroxide (Conc.< 52%)",
        ],
        t2mChemicalName: "Hydrogen Peroxide (Conc.< 52%)",
        componentPercentageLowerBoundInclusive: 0,
        componentPercentageUpperBoundInclusive: 52,
        ehs: false,
    },
    {
        casNumber: "7664939",
        encampChemicalNames: ["Electrolyte (solution of sulfuric acid and water)", "Sulfuric Acid"],
        t2mChemicalName: "Sulfuric acid",
        ehs: true,
    },
];
//# sourceMappingURL=states.js.map